var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Experiences / Language"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8045 4.50024C17.6215 5.54377 19.6919 8.11393 19.9998 11.2H16.8071C16.6772 8.09533 15.7992 5.91663 14.809 4.50194L14.8045 4.50024ZM11.9999 4C9.5537 5.15358 8.87355 8.86788 8.76676 11.2H15.1977C15.086 8.76125 14.3904 5.31804 11.9999 4ZM9.1429 4.51987C8.15789 5.93498 7.28669 8.10842 7.15733 11.2H4C4.30601 8.1331 6.35261 5.57573 9.1429 4.51987ZM14.8047 19.4998C17.6217 18.4562 19.6921 15.8861 20 12.8H16.8073C16.6774 15.9047 15.7994 18.0834 14.8092 19.4981L14.8047 19.4998ZM12.0001 20C9.55389 18.8464 8.87375 15.1321 8.76695 12.8H15.1979C15.0862 15.2388 14.3906 18.682 12.0001 20ZM9.1431 19.4801C8.15809 18.065 7.28689 15.8916 7.15752 12.8H4.0002C4.3062 15.8669 6.3528 18.4243 9.1431 19.4801Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageSidebar);
export default __webpack_public_path__ + "static/media/language-sidebar.145f2a3ed87f3614296367c9f3fe8411.svg";
export { ForwardRef as ReactComponent };